/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'open-view': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#B7CAD4" d="M6.914 3h4.663L5.5 9.077l1.414 1.414 6.077-6.077v4.663h2V1H6.914v2z"/><path pid="1" _fill="#B7CAD4" d="M5 3v2H3v8h8v-2h2v4H1V3h4z"/>'
  }
})
